import { createRoot } from "react-dom/client";
import "@mantine/core/styles.css";
import "./index.css";
import "./App.css";
import { PrimeReactProvider } from "primereact/api";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { MantineProvider } from "@mantine/core";
import React, { Suspense } from "react";
import Loader from "./components/Users/Loader.jsx";
const App = React.lazy(() => import("./App"));
createRoot(document.getElementById("root")).render(
  <Suspense fallback={<Loader />}>
    <PrimeReactProvider>
      <MantineProvider>
        <App />
      </MantineProvider>
    </PrimeReactProvider>
  </Suspense>
);
